import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { ConexionesDetalleContent } from './components/ConexionesDetalleContent';

export default function AdminConexionesDetalle() {

    return (
        <>
            <MainContent
                component={<ConexionesDetalleContent />}
                titulo={'Detalle de Conexiones'}
                noBackground
                tableMaxWidth
            />
        </>
    );
};
